/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Sales_Src_2_DetailInputs */

const en_wb_sales_src_2_detail = /** @type {(inputs: Wb_Sales_Src_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account history and notes`)
};

const lv_wb_sales_src_2_detail = /** @type {(inputs: Wb_Sales_Src_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klienta vēsture un piezīmes`)
};

/**
* | output |
* | --- |
* | "Account history and notes" |
*
* @param {Wb_Sales_Src_2_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_sales_src_2_detail = /** @type {((inputs?: Wb_Sales_Src_2_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Sales_Src_2_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_sales_src_2_detail(inputs)
	return en_wb_sales_src_2_detail(inputs)
});